const PAYMENT_LIMIT_DAYS = {
  credito: 180,
  debito: 7,
  pix: 90,
};

export function isPaymentDateOverLimit(
  paymentDate: string | Date,
  paymentMethod: string,
): boolean {
  const date = new Date(paymentDate);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  if (paymentMethod === "credito") {
    return diffInDays < PAYMENT_LIMIT_DAYS.credito;
  }
  if (paymentMethod === "debito") {
    return diffInDays < PAYMENT_LIMIT_DAYS.debito;
  }
  if (paymentMethod === "pix") {
    return diffInDays < PAYMENT_LIMIT_DAYS.pix;
  }

  return false;
}
